import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSelectors } from '@exodus/headless-ui';
const filterDisabledAssets = (enabledAssets, useAllAvailable) => (asset) => {
    return useAllAvailable ? true : !!enabledAssets[asset.name];
};
const enhanceAssets = (rates, walletAccount, getSpendableBalance) => (asset) => {
    const assetRates = rates[asset.ticker];
    const assetSource = { assetName: asset.name, walletAccount: walletAccount.toString() };
    const amount = getSpendableBalance(assetSource)?.toDefaultNumber() ?? 0;
    const fiatAmount = parseFloat((amount * (assetRates?.price ?? 0)).toFixed(6));
    return { ...asset, amount, fiatAmount, cap: assetRates?.cap ?? 0 };
};
const sortAssets = (a, b) => {
    return a.fiatAmount === 0 && b.fiatAmount === 0 ? b.cap - a.cap : b.fiatAmount - a.fiatAmount;
};
const useBaseAssets = ({ assets, walletAccount, query }) => {
    const selectors = useSelectors();
    const rates = useSelector(selectors.rates.fiatRates);
    const enabledAssets = useSelector(selectors.enabledAssets.data);
    const getSpendableBalance = useSelector(selectors.balances.getSpendable);
    return useMemo(() => {
        return assets
            .filter(filterDisabledAssets(enabledAssets, Boolean(query)))
            .map(enhanceAssets(rates, walletAccount, getSpendableBalance))
            .sort(sortAssets);
    }, [query, assets, enabledAssets, rates, walletAccount, getSpendableBalance]);
};
export default useBaseAssets;
